import React from 'react';
import Hero from '../components/Hero';
import Accomplishments from '../components/Accomplishments';
import FeaturedWork from '../components/FeaturedWork';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div data-testid="home-page">
      <Hero />
      <Accomplishments />
      <FeaturedWork />
      <Footer />
    </div>
  );
};

export default Home;